module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "el-button",
    class: [
      _vm.type ? 'el-button--' + _vm.type : '',
      _vm.buttonSize ? 'el-button--' + _vm.buttonSize : '',
      {
        'is-disabled': _vm.buttonDisabled,
        'is-loading': _vm.loading,
        'is-plain': _vm.plain,
        'is-round': _vm.round,
        'is-circle': _vm.circle
      }
    ],
    attrs: {
      "disabled": _vm.buttonDisabled || _vm.loading,
      "autofocus": _vm.autofocus,
      "type": _vm.nativeType
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "el-icon-loading"
  }) : _vm._e(), _vm._v(" "), (_vm.icon && !_vm.loading) ? _c('i', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.default) ? _c('span', [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79f5c128"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/element-ui/packages/button/src/button.vue
// module id = 840
// module chunks = 1